<section class="comment-container">
  @for(comment of comments(); track comment.id){
    <article class="comment-wrapper"
         [class.own-comment]="comment.author?.oid === currentUser()?.oid"
         [class.other-comment]="comment.author?.oid !== currentUser()?.oid"
         [class.impossible-comment]="comment.isCheckImpossible"
         [class.info-comment]="comment.status === commentStatus.info"
         [class.done-comment]="comment.status === commentStatus.done">
      <div class="comment-author">
        @if(!isReadOnly() && canDelete(comment)){
          <button mat-icon-button (click)="deleteComment(comment.id)" class="comment-label"><mat-icon>delete</mat-icon></button>
        }
        @else {
          <div class="comment-label"><mat-icon>empty</mat-icon></div>
        }
        <mat-chip>{{comment.author?.displayName}}</mat-chip>
      </div>
      <div class="comment-content">
        @if (comment.isCheckImpossible) {
          <mat-icon class="impossible-icon">warning</mat-icon>
        }
        <p class="comment-text">{{comment.content}}</p>
        @if(comment.isCheckImpossible){
          @if(!isReadOnly()){
            <mat-slide-toggle [checked]="comment.status === commentStatus.done"
                              (change)="toggleChanged(comment, $event.checked)">
            </mat-slide-toggle>
          }
        }
        @else {
          @if(!isReadOnly() && isAuthor(comment)){
            <button mat-stroked-button
                    class="info-type-btn"
                    [class.info-btn-active]="comment.status === commentStatus.info"
                    [class.info-btn-inactive]="comment.status !== commentStatus.info"
                    [matTooltip]="comment.status === commentStatus.info ? 'Zu normalem Kommentar wechseln' : 'Als Info-Kommentar markieren'"
                    (click)="toggleInfoStatus(comment)">
              <mat-icon>{{ comment.status === commentStatus.info ? 'bookmark' : 'bookmark_border' }}</mat-icon>
              Info
            </button>
          }
          @if(comment.status !== commentStatus.info && !isReadOnly()){
            <mat-slide-toggle [checked]="comment.status === commentStatus.done"
                              (change)="toggleChanged(comment, $event.checked)">
            </mat-slide-toggle>
          }
        }
      </div>
    </article>
  }

</section>
